import { combineReducers } from 'redux';
import appReducer from 'ui/containers/App/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export const createReducer = (injectedReducers = {}) => {
  const rootReducer = combineReducers({
    global: appReducer,
    // router: connectRouter(history),
    ...injectedReducers,
  });

  return rootReducer;
};
